import { useEffect, useState } from 'react';
import { ITicker } from '@kattana-io/common';
import Text from '../../atoms/Text';
import PairsTable from '../../components/SEO/PairsTable';
import { ColumnNames } from '../../components/Modal/TickersModal/helpers';
import ExchangeIcon from '../../components/Modal/TickersModal/ChainExchangeSelector/ExchangeIcon';
import TickerCell from '../../components/DexTrades/TickerCell';
import TableContractField from '../../components/TableComponents/Contract';
import { getTokenTableData } from './helpers';
import NumberDisplay from '../../molecules/NumberDisplay';

const headers = [
  {
    id: ColumnNames.star,
    Header: '#',
    width: 40,
    left: true,
    filterable: true,
  },
  {
    id: ColumnNames.pair,
    Header: 'Pair',
    width: 150,
    left: true,
    filterable: false,
  },
  {
    id: ColumnNames.exchange,
    Header: 'Source',
    width: 110,
    left: true,
    filterable: false,
  },
  {
    id: ColumnNames.price,
    Header: 'Price',
    width: 110,
    filterable: true,
  },
  {
    id: ColumnNames.liquidity,
    Header: 'Liquidity',
    width: 128,
    filterable: true,
  },
  {
    id: ColumnNames.volume,
    Header: 'Volume',
    width: 110,
    filterable: true,
  },
  {
    id: ColumnNames.apy,
    Header: 'APY',
    width: 110,
    filterable: true,
  },
  {
    id: ColumnNames.contract,
    Header: 'Contract',
    width: 176,
    filterable: false,
  },
];

interface IPairsTableProps {
  title: string;
  pairs?: ITicker[];
}

const TokenPairsTable = ({ title, pairs }: IPairsTableProps) => {
  const [tableData, setTableData] = useState<
    Record<ColumnNames, string | number>[]
  >([]);

  useEffect(() => {
    if (pairs && pairs.length > 0) {
      setTableData(getTokenTableData(pairs));
    }
  }, [pairs]);

  const renderCell = (
    cell: any,
    item: Record<string, string>,
    index: number
  ) => {
    const ticker = pairs?.[index];

    switch (cell.id) {
    case ColumnNames.star:
      return (
        <Text size={12} className='text--weight-500'>
          {item[cell.id]}
        </Text>
      );
    case ColumnNames.exchange:
      return (
        <ExchangeIcon
          textProps={{
            className: 'text--weight-600 text--grey-200',
            size: 12,
          }}
          imageProps={{
            style: {
              order: -1,
              marginRight: 8,
              width: 24,
              height: 24,
            },
          }}
          exchange={item[cell.id]}
          chain={ticker?.chain || ''}
        />
      );
    case ColumnNames.price:
      return (
        <NumberDisplay
          value={Number(item[cell.id])}
          startSymbol='$'
          textProps={{ size: 12 }}
        />
      );
    case ColumnNames.pair:
      return (
        <div className='seo_page__table__content__pair_cell'>
          <TickerCell path={item[cell.id]} ticker={ticker} />
        </div>
      );
    case ColumnNames.contract:
      return (
        <TableContractField
          address={item[cell.id]}
          chain={ticker?.chain || ''}
        />
      );
    default:
      return <Text size={12}>{item[cell.id]}</Text>;
    }
  };

  return (
    <PairsTable
      title={title}
      headers={headers}
      data={tableData}
      renderCell={renderCell}
      initSortColumn={ColumnNames.liquidity}
    />
  );
};

export default TokenPairsTable;
